import React, { useMemo } from 'react';

import { TBlock } from '@wp-block-builder/package';

import { TColumnsSectionBlock } from '../';
import TableCell from '../TableCell';
import useBlockProps from '../useBlockProps';

type TChildBlockRenderer = (block: TBlock | null, index: number) => JSX.Element;

type Props = {
  block: TColumnsSectionBlock;
  renderChildBlock: TChildBlockRenderer;
};
export default function DesktopBlockLayout({ block, renderChildBlock }: Props) {
  const blockProps = useBlockProps(block);

  const children = useMemo(() => {
    if (blockProps.columnsCount === 3) {
      return (
        <>
          <TableCell index={0} blockProps={blockProps} renderChildBlock={renderChildBlock} />
          <TableCell index={1} blockProps={blockProps} renderChildBlock={renderChildBlock} />
          <TableCell index={2} blockProps={blockProps} renderChildBlock={renderChildBlock} />
        </>
      );
    }
    return (
      <>
        <TableCell index={0} blockProps={blockProps} renderChildBlock={renderChildBlock} />
        <TableCell index={1} blockProps={blockProps} renderChildBlock={renderChildBlock} />
      </>
    );
  }, [blockProps, renderChildBlock]);

  return (
    <div className={blockProps.mobileLayout === 'stacked' ? 'block-desktop' : ''}>
      <table
        align="center"
        width="100%"
        cellPadding="0"
        border={0}
        style={{ tableLayout: 'fixed', borderCollapse: 'collapse' }}
      >
        <tbody style={{ width: '100%' }}>
          <tr style={{ width: '100%' }}>{children}</tr>
        </tbody>
      </table>
    </div>
  );
}
